import { ReviewSectionComponent } from './../review-section/review-section.component';
import { SectionIdentifier, ShowButtonsPredicateContext } from 'src/app/+shared/components/review-section/review-section.domain';
import { EnvironmentService } from 'src/app/services/environment.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { InstallationFlowType } from 'src/app/constants/app.constants';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactPersonService } from 'src/app/+grid-compatibility/services/contact-person.service';
import { DestroyableComponent } from 'src/app/common/destroyable.component';
import { ErrorService } from 'src/app/services/error/error.service';

@Component({
  selector: 'app-contact-person',
  templateUrl: './contact-person.component.html',
  styleUrls: ['./contact-person.component.scss'],
})
export class ContactPersonComponent extends DestroyableComponent implements OnInit {
  public currentInstallationFlow = this.localStorageService.getItem('installation_flow') || '';
  public installationFlowType = InstallationFlowType;
  public form: FormGroup;
  public sectionIdentifier = SectionIdentifier;

  constructor(
    public environmentService: EnvironmentService,
    private localStorageService: LocalStorageService,
    private contactPersonService: ContactPersonService,
    private errorService: ErrorService
  ) {
    super();
  }

  @Output() initForm = new EventEmitter<FormGroup>();
  @Input() data: any;
  @Input() isDetailsView: boolean;
  @Input() applicationId: string | number;
  @Input() checkIfIsEditable: any;
  @Input() forceAllowAddMessages: boolean | null = null;

  @ViewChild('reviewSection') reviewSection: ReviewSectionComponent;

  ngOnInit(): void {
    this.form = new FormGroup({
      id: new FormControl(0),
      name: new FormControl('', [Validators.required]),
      phone: new FormControl('', [Validators.required]),
      application_id: new FormControl(this.applicationId, [Validators.required]),
    });

    if (this.data) {
      this.form.setValue({ id: this.data.id, name: this.data.name, phone: this.data.phone, application_id: this.applicationId });
    }

    if (this.reviewSection && !this.reviewSection.isDataEditable) {
      this.form.disable();
    }

    this.initForm.emit(this.form);
  }

  onReviewSectionChange(reviewSectionComponent: ReviewSectionComponent) {
    if (!reviewSectionComponent.isDataEditable) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  // this is used only from details view;
  saveChanges(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.preventLeak(this.contactPersonService.upsert(this.form.value)).subscribe(
        response => {
          this.errorService.rejectIfError(response, reject);
          this.errorService.throwErrorIfFailure(response, false);
          resolve();
        },
        error => {
          reject(error);
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    });
  }
}
